/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Deft_Ram_PushInputs */

const en_sharp_deft_ram_push = /** @type {(inputs: Sharp_Deft_Ram_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by share`)
};

const de_sharp_deft_ram_push = /** @type {(inputs: Sharp_Deft_Ram_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Freigabe filtern`)
};

/**
* | output |
* | --- |
* | "Filter by share" |
*
* @param {Sharp_Deft_Ram_PushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sharp_deft_ram_push = /** @type {((inputs?: Sharp_Deft_Ram_PushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Deft_Ram_PushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharp_deft_ram_push(inputs)
	return de_sharp_deft_ram_push(inputs)
});